import React, { useState } from 'react';
import './CustomPaintJobs.css';

const customPaintJobs = [
  { name: 'Classic Gloss Black', filename: 'paint black.jpg' },
  { name: 'Classic Gloss Black 2', filename: 'paint black 2.jpg' },
  { name: 'Catwoman tanks', filename: 'paint cat1.jpg' },
  { name: 'Catwoman w/led eyes', filename: 'paint cat 2.jpg' },
  { name: 'Demon tank', filename: 'paint demon tank.jpg' },
  { name: 'Candy flames on black', filename: 'paint flame 2.jpg' },
  { name: 'Flamed Fatboy', filename: 'paint flame 4.jpg' },
  { name: 'Stretched tank flamed', filename: 'paint flame 5.jpg' },
  { name: 'Overlap flames on tank', filename: 'paint flame 6.jpg' },
  { name: 'Overlap flames on tank cham', filename: 'paint flame 7 cham.jpg' },
  { name: 'Grateful Dead cover', filename: 'paint gd2.jpg' },
  { name: 'Sample of paint work', filename: 'paint icon.jpg' },
  { name: 'Leopard paint', filename: 'paint leopard.jpg' },
  { name: 'Overlap flames on oil tank', filename: 'paint oil tank flame.jpg' },
  { name: 'Don Quixote', filename: 'paint pavl.jpg' },
  { name: 'Comic book artwork', filename: 'paint sw1.jpg' },
  { name: 'Tattoo artwork', filename: 'paint sw2.jpg' },
  { name: 'Dyna Wide Glide', filename: 'paint tankframe.jpg' },
  { name: 'Tribal paint 1', filename: 'paint tribal1.jpg' },
  { name: 'Tribal paint 2', filename: 'paint tribal2.jpg' },
  { name: 'Built from scratch', filename: 'paint xl tank.jpg' },
  { name: 'Where the magic happens', filename: 'paint zbooth.jpg' },
  { name: 'Grateful Dead tank', filename: 'paint_GD_tank.jpg' },
  { name: 'Rat Fink?', filename: 'RFINK.jpeg' },
];

export default function CustomPaintJobs() {
  // For a simple lightbox effect
    const [selectedImg, setSelectedImg] = useState(null);
  
  return (
    <div className="certificates-container">
      <h1>Custom Paint Jobs</h1>

      <div className="certificates-gallery">
        {customPaintJobs.map((job, idx) => (
          <div className="certificate-card" key={idx}>
            <img
              src={`/Assets/CustomPaintJobs/${job.filename}`}
              alt={job.name}
              className="certificate-img"
              onClick={() => setSelectedImg(
                  `/Assets/CustomPaintJobs/${encodeURIComponent(job.filename)}`
                )}
              style={{ cursor: 'pointer' }}
            />
            <div className="certificate-title">{job.name}</div>
          </div>
        ))}
      </div>
{selectedImg && (
          <div className="lightbox" onClick={() => setSelectedImg(null)}>
            <img
              src={selectedImg}
              alt="Enlarged Bob Belfi pic"
              className="lightbox-img"
            />
          </div>
        )}
    </div>
  );
}
